import React from 'react';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { getEmailDefaults, type EmailDefaults } from '../lib/api/envelope/envelope-api';

export function useEmailDefaults(emailId: string, options?: UseQueryOptions<EmailDefaults>) {
  const queryResult = useQuery<EmailDefaults>(
    ['email-defaults', emailId],
    async () => {
      return getEmailDefaults(emailId);
    },
    options
  );

  React.useEffect(() => {
    if (queryResult.isError) {
      console.error('Failed to fetch email defaults, falling back to hardcoded placeholders');
    }
  }, [queryResult.isError]);

  return queryResult;
}
